"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Card;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("../headline-lockup/index.js"));
var _index2 = _interopRequireDefault(require("../section-item/index.js"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
/**
 * Card component.
 * @module Card
 *
 * @param {Object} props React props
 * @param {String} props.id Id
 * @param {string} props.padding Padding enum from Section Item
 * @param {string} props.tagLabel Label text
 * @param {string} props.labelDesign Label background color
 * @param {string} props.labelSize Label size sm,lg
 * @param {Boolean} props.rounded rounded
 * @param {Object|React.ReactElement} props.priceLockup Price Lockup component
 * @param {Object} props.backgroundColor Item background color
 * @param {string} [props.textAlign='start'] Text alignment
 * @returns {React.ReactElement} Card lockup component
 * @public
 */
function Card({
  id,
  padding = 'small',
  indented,
  tagLabel,
  labelDesign = 'warning',
  labelSize,
  rounded,
  backgroundColor,
  textAlign = 'start',
  headlineSize = 'h3',
  priceLockup,
  ...headlineProps
}) {
  const cardPriceLockup = priceLockup || headlineProps.priceLockup;
  return /*#__PURE__*/_react.default.createElement(_index2.default, {
    id: `id-${id}`,
    padding: padding,
    indented: indented,
    rounded: rounded,
    textAlign: textAlign,
    backgroundColor: backgroundColor,
    dataCy: "card"
  }, tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tagLabel,
    design: labelDesign,
    size: labelSize
  }), /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, headlineProps, {
    headlineSize: headlineSize,
    textAlign: textAlign,
    priceLockup: cardPriceLockup
  })));
}
Card.propTypes = {
  backgroundColor: _propTypes.default.object,
  id: _propTypes.default.string,
  tagLabel: _propTypes.default.string,
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),
  rounded: _propTypes.default.bool,
  padding: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  headlineSize: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  priceLockup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  ..._index.default.propTypes
};